import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider, useAuth } from './context/AuthContext';

import Landing from './pages/marketing/Landing';
import Pricing from './pages/marketing/Pricing';
import Features from './pages/marketing/Features';
import SubPage from './pages/marketing/SubPage';
import Login from './pages/auth/Login';
import Signup from './pages/auth/Signup';
import AuthCallback from './pages/auth/AuthCallback';

import DashboardLayout from './pages/app/DashboardLayout';
import Dashboard from './pages/app/Dashboard';
import Projects from './pages/app/Projects';
import CreateVideo from './pages/app/CreateVideo';
import ProjectStudio from './pages/app/ProjectStudio';
import ImageStudio from './pages/app/ImageStudio';
import Billing from './pages/app/Billing';
import { Templates, BrandKit, AudioLibrary, Settings } from './pages/app/SimplePages';
import { PaymentSuccess, PaymentCancel } from './pages/payment/PaymentResult';

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400 font-mono text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/features" element={<Features />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/ai-editor" element={<SubPage slug="ai-editor" />} />
      <Route path="/voiceover" element={<SubPage slug="voiceover" />} />
      <Route path="/music" element={<SubPage slug="music" />} />
      <Route path="/images-broll" element={<SubPage slug="images-broll" />} />
      <Route path="/shorts" element={<SubPage slug="shorts" />} />
      <Route path="/templates" element={<SubPage slug="templates" />} />
      <Route path="/blog" element={<SubPage slug="blog" />} />
      <Route path="/help" element={<SubPage slug="help" />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />

      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />

      <Route path="/app" element={<Protected><DashboardLayout /></Protected>}>
        <Route index element={<Dashboard />} />
        <Route path="projects" element={<Projects />} />
        <Route path="create" element={<CreateVideo />} />
        <Route path="studio/:id" element={<ProjectStudio />} />
        <Route path="thumbnails" element={<ImageStudio />} />
        <Route path="templates" element={<Templates />} />
        <Route path="brand-kit" element={<BrandKit />} />
        <Route path="audio" element={<AudioLibrary />} />
        <Route path="settings" element={<Settings />} />
        <Route path="billing" element={<Billing />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
